import { Box, Card, Collapse, GridLegacy } from "@mui/material";
import React from "react";
import CardBody from "../../../../components/Card/CardBody";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import { useFormContext, useWatch } from "react-hook-form";
import MenuSyncSettings from "../MenuSyncSettings";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import { CustomizableTexts } from "../../../../components/CustomizableTexts/CustomizableTexts";

function Vectron() {
  const { menukaartVestigingId, vestigingId } = useFormContext();
  const checkTableIsEnabled = useWatch({ name: "custom_data.check_table_is_open.enabled" });
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Vectron"} tKey={"vestigingen.form.vectron.headers.vectron"} />
              </h3>
            </GridLegacy>
            <FormTextTC
              name={"vectronSignature"}
              tDefault={"Signature"}
              tKey={"vestigingen.form.vectron.label.vectronSignature"}
            />
            <FormTextTC name={"vectronToken"} tDefault={"Token"} tKey={"vestigingen.form.vectron.label.vectronToken"} />
            <FormTextTC
              name={"vectronServer"}
              tDefault={"Server"}
              tKey={"vestigingen.form.vectron.label.vectronServer"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <FormTextTC
              name={"vectronPaymentID"}
              tDefault={"Vectron payment ID"}
              tKey={"vestigingen.form.vectron.label.vectronPaymentID"}
            />
            <FormTextTC
              name={"vectronPriceID"}
              tDefault={"Vectron price ID"}
              tKey={"vestigingen.form.vectron.label.vectronPriceID"}
            />
            <FormSwitchTC
              name={"vectronGetFreeTable"}
              tDefault={"Get free table"}
              tKey={"vestigingen.form.vectron.label.vectronGetFreeTable"}
            />
            <FormSwitchTC
              name={"vectronTableComments"}
              tDefault={"Tafel als info icm get free table"}
              tKey={"vestigingen.form.vectron.label.vectronTableComments"}
            />
            <FormSwitchTC
              name={"vectronPreserveMenuNames"}
              tDefault={"Do not overwrite Menu Names"}
              tKey={"vestigingen.form.vectron.label.vectronPreserveMenuNames"}
            />
            <FormSwitchTC
              name={"vectronPreserveAlteredProductNames"}
              tDefault={"Do not overwrite Menu Names"}
              tKey={"vestigingen.form.vectron.label.vectronPreserveAlteredProductNames"}
            />
            <FormSwitchTC
              name={"vectronForceJamezzPrice"}
              tDefault={"Force Jamezz price"}
              tKey={"vestigingen.form.vectron.label.forceJamezzPrice"}
            />
            <FormSwitchTC
              name={"vectronUsePriceLevel"}
              tDefault={"Vectron use PriceLevel"}
              tKey={"vestigingen.form.vectron.label.vectronUsePriceLevel"}
            />
            <FormTextTC
              name={"default_min_select"}
              tDefault={"Default min select"}
              tKey={"vestigingen.form.vectron.label.defaultMinSelect"}
            />
            <FormTextTC
              name={"defMaxSelect"}
              tDefault={"Default max select"}
              tKey={"vestigingen.form.vectron.label.defaultMaxSelect"}
            />
            <FormSwitchTC
              name={"useWithoutTableOverlappingMiddleware"}
              tDefault={"Don't overlap table request"}
              tKey={"vestigingen.form.overige.label.useWithoutTableOverlappingMiddleware"}
            />
            <FormSwitchTC
              name={"apiaccounts__vectronSentDeliveryTime"}
              tDefault={"Send time as parameter for KDS"}
              tKey={"vestigingen.form.overige.label.vectronDeliveryDateAsParameter"}
            />

            <FormSwitchTC
              name={"custom_data.check_table_is_open.enabled"}
              tDefault={"Check table is open before allowing ordering"}
              tKey={"custom_data.check_table_is_open.enabled"}
            />

            <Box>
              <Collapse in={!!checkTableIsEnabled}>
                <CustomizableTexts
                  translatableTexts={["check_table_is_closed_message", "check_table_is_open_message"]}
                  vestigingId={vestigingId}
                />
              </Collapse>
            </Box>
            <MenuSyncSettings />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Vectron;
